import axios from 'axios';

import BaseCrud from './baseCrud';

const crud = new BaseCrud('course', 'courses');

export const state = () => ({
    ...crud.state,
    PAYMENT_METHOD_CASH: 'cash',
    PAYMENT_METHOD_CHECK: 'check',
    PAYMENT_METHOD_CREDIT: 'credit',
    PAYMENT_METHOD_ONLINE: 'online',
    PAYMENT_METHOD_DICANATT: 'dicanatt',
    PAYMENT_METHOD_STARS: 'stars',
    PAYMENT_METHOD_CREDIT_AND_STARS: 'credit&stars',
    STATUS_JOINED: 'joined',
    STATUS_CANCELLED: 'cancelled',
    STATUS_PENDING_PAYMENT: 'pending_payment'
});

export const getters = {
    ...crud.getters,
    PAYMENT_METHODS: state => [
        state.PAYMENT_METHOD_CASH,
        state.PAYMENT_METHOD_CHECK,
        state.PAYMENT_METHOD_CREDIT,
        state.PAYMENT_METHOD_ONLINE,
        state.PAYMENT_METHOD_DICANATT,
        state.PAYMENT_METHOD_STARS
    ],
    REFUNDABLE_PAYMENT_METHODS: state => [
        state.PAYMENT_METHOD_STARS,
        state.PAYMENT_METHOD_CREDIT,
        state.PAYMENT_METHOD_CREDIT_AND_STARS
    ],
    PAYMENT_METHOD_STARS: state => state.PAYMENT_METHOD_STARS,
    PAYMENT_METHOD_CREDIT: state => state.PAYMENT_METHOD_CREDIT,
    PAYMENT_METHOD_CREDIT_AND_STARS: state =>
        state.PAYMENT_METHOD_CREDIT_AND_STARS,
    STATUS_JOINED: state => state.STATUS_JOINED,
    STATUS_CANCELLED: state => state.STATUS_CANCELLED,
    STATUS_PENDING_PAYMENT: state => state.STATUS_PENDING_PAYMENT,
    ALL_STATUSES: state => [
        state.STATUS_JOINED,
        state.STATUS_CANCELLED,
        state.STATUS_PENDING_PAYMENT
    ]
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    getUsers(
        ctx,
        {
            id,
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'Course2User.createdAt',
            descending = true,
            filters = null,
            status = null
        }
    ) {
        const params = {
            status,
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get(`/admin/courses/${id}/users`, {
            params
        });
    },

    sendMessage(ctx, { id, type, message, status }) {
        return axios.$post(`/admin/courses/${id}/send-${type}`, {
            status,
            message
        });
    },

    publish(ctx, id) {
        return axios.$post(`/admin/courses/${id}/publish`);
    },

    addUser(ctx, { id, ...data }) {
        return axios.$post(`/admin/courses/${id}/users/add`, data);
    },

    changeCourse(ctx, { id, ...data }) {
        return axios.$post(`/admin/courses/${id}/users/change`, data);
    },

    cancelRegistration(ctx, { id, ...data }) {
        return axios.$post(`/admin/courses/${id}/users/cancel`, data);
    },

    refund(ctx, { id, ...data }) {
        return axios.$post(`/admin/courses/${id}/users/refund`, data);
    },

    getRegistrationDatesRange() {
        return axios.$get(`/admin/courses/registration/dates`);
    },

    changeRegistrationDatesRange(ctx, { id, ...data }) {
        return axios.$patch(`/admin/courses/${id}/registration-dates`, data);
    },

    getOrders(
        ctx,
        {
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get('/admin/courses/orders/list', {
            params
        });
    }
};
